<template>
  <div class="mobile_vote">
    <div class="vote_apply_head" ref="voteApplyHead">
      <div>
        {{ meetingInfo.MeetingName }}
      </div>
    </div>
    <div class="vote_apply_bar" :style="voteApplyBarStyle">
      <!-- <div><strong>会议时间</strong></div>
      <div>
        {{ meetingInfo.StartTime | dateformat('YYYY年MM月DD日 HH:mm') }}
        -
        {{ meetingInfo.EndTime | dateformat('YYYY年MM月DD日 HH:mm') }}
      </div>
      <div v-show="meetingInfo.Contents"><strong>会议内容</strong></div>
      <div>
        {{ meetingInfo.Contents }}
      </div> -->
      <div>
        <strong> {{ meetingInfo.ApplyButtonText }}截止时间 </strong>
      </div>
      <div>
        {{ meetingInfo.ApplyDeadlineTime | dateformat('YYYY年MM月DD日 HH:mm') }}
      </div>
    </div>
    <div class="vote_apply_form" v-show="viewType === 'form'">
      <el-form
        :model="voteUserApplyForm"
        :rules="voteUserApplyFormRules"
        ref="voteUserApplyForm"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="姓名：" prop="UserName">
          <el-input
            ref="UserName"
            v-model="voteUserApplyForm.UserName"
            placeholder="请输入姓名"
            prefix-icon="el-icon-user-solid"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="Phone">
          <el-input
            ref="Phone"
            v-model="voteUserApplyForm.Phone"
            placeholder="请输入手机号"
            prefix-icon="el-icon-phone"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="公司单位：" prop="UnitName">
          <el-input
            v-model="voteUserApplyForm.UnitName"
            placeholder="请输入公司单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门：" prop="Department">
          <el-input
            v-model="voteUserApplyForm.Department"
            placeholder="请输入部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="职务：" prop="Position">
          <el-input
            v-model="voteUserApplyForm.Position"
            placeholder="请输入职务"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否代人参会：" prop="IsAgent">
          <el-radio-group v-model="voteUserApplyForm.IsAgent" size="small">
            <el-radio-button :label="false">本人</el-radio-button>
            <el-radio-button :label="true">代人参会</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="授权人姓名："
          prop="ClientName"
          v-if="voteUserApplyForm.IsAgent"
        >
          <el-input
            ref="ClientName"
            v-model="voteUserApplyForm.ClientName"
            placeholder="请输入授权人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="授权人手机号："
          prop="ClientPhone"
          v-if="voteUserApplyForm.IsAgent"
        >
          <el-input
            ref="ClientPhone"
            v-model="voteUserApplyForm.ClientPhone"
            placeholder="请输入授权人手机号"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      width="300px"
      :visible.sync="pictureRotateVerifyVisible"
      append-to-body
      :close-on-click-modal="false"
      custom-class="pictureRotateVerifgClass"
    >
      <div class="picture_rotate_verify_box">
        <div class="picture_rotate_verify_head">安全验证</div>
        <div class="picture_rotate_verify_desc">拖动滑块，使图片角度为正</div>
        <div class="picture_rotate_verify_picbox">
          <img
            class="vcode_spin_img"
            :src="verifyImageCode"
            :style="vcodeImgStyle"
          />
          <span class="vcode_warning" v-if="isShowVcodeWarning">
            <i class="el-icon-close"></i>
          </span>
          <el-alert title="验证码错误" type="error" v-if="isShowVcodeWarning">
          </el-alert>
        </div>
        <div class="picture_rotate_verify_slider">
          <div
            class="picture_rotate_slider_left"
            :style="sliderLeftStyle"
          ></div>
          <div class="picture_rotate_slider_main">
            <el-slider
              v-model="pictureRotateNum"
              :show-tooltip="false"
              :max="360"
              @input="pictureRotateInput()"
              @change="submitUserApply()"
            ></el-slider>
          </div>
          <div class="picture_rotate_slider_right"></div>
        </div>
      </div>
    </el-dialog>
    <div class="vote_apply_form" v-show="viewType === 'detaile'">
      <el-form class="demo-ruleForm" label-position="left" label-width="110px">
        <el-form-item label="姓名：" prop="UserName">
          {{ userApplyInfo.UserName }}
        </el-form-item>
        <el-form-item label="手机号：" prop="Phone">
          {{ userApplyInfo.Phone }}
        </el-form-item>
        <el-form-item label="公司单位：" prop="UnitName">
          {{ userApplyInfo.UnitName }}
        </el-form-item>
        <el-form-item label="部门：" prop="Department">
          {{ userApplyInfo.Department }}
        </el-form-item>
        <el-form-item label="职务：" prop="Position">
          {{ userApplyInfo.Position }}
        </el-form-item>
        <el-form-item label="是否代人参会：" prop="IsAgent">
          <span v-if="!userApplyInfo.IsAgent">本人</span>
          <span v-if="userApplyInfo.IsAgent">代人参会</span>
        </el-form-item>
        <el-form-item
          label="授权人姓名："
          prop="ClientName"
          v-if="userApplyInfo.IsAgent"
        >
          {{ userApplyInfo.ClientName }}
        </el-form-item>
        <el-form-item
          label="授权人手机号："
          prop="ClientPhone"
          v-if="userApplyInfo.IsAgent"
        >
          {{ userApplyInfo.ClientPhone }}
        </el-form-item>
      </el-form>
    </div>
    <div class="vote_apply_form_bar">
      <!-- <el-button @click="getBack()">返回登录</el-button> -->
      <el-button
        type="primary"
        style="padding-left: 30px; padding-right: 30px"
        @click="openSubmitUserApplyVerify('voteUserApplyForm')"
        v-if="viewType === 'form'"
      >
        {{ meetingInfo.ApplyButtonText }}
      </el-button>
      <el-button
        type="primary"
        style="padding-left: 30px; padding-right: 30px"
        @click="addUserApply()"
        v-if="viewType === 'detaile'"
      >
        继续{{ meetingInfo.ApplyButtonText }}
      </el-button>
    </div>
  </div>
</template>
<script>
import meetingManageApi from '../../api/meetingManage'
import userApplyApi from '../../api/vote/userApply'
import verificationCodeApi from '../../api/verificationCode'
export default {
  data () {
    const phoneReg = /^1[0-9]{10}$/
    const validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      meetingInfo: {},
      voteApplyBarStyle: {
        marginTop: '45px'
      },
      voteUserApplyForm: {
        Id: null,
        UserName: null,
        Phone: null,
        UnitName: null,
        Department: null,
        Position: null,
        IsAgent: false,
        ClientName: null,
        ClientPhone: null,
        CompanyID: null,
        MeetingID: null
      },
      voteUserApplyFormRules: {
        UserName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }],
        Phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }],
        UnitName: [
          { min: 1, max: 1000, message: '公司单位名称过长', trigger: 'blur' }],
        Department: [
          { min: 1, max: 1000, message: '部门名称过长', trigger: 'blur' }],
        Position: [
          { min: 1, max: 100, message: '职务信息过长', trigger: 'blur' }],
        ClientName: [
          { required: true, message: '请输入授权人姓名', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }],
        ClientPhone: [
          { required: true, message: '请输入授权人手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }]
      },
      userApplyInfo: {},
      viewType: 'form',
      pictureRotateVerifyVisible: false,
      pictureRotateNum: 0,
      sliderLeftStyle: {
        backgroundColor: '#e4e7ed'
      },
      vcodeImgStyle: {
        transform: 'rotate(0deg)'
      },
      verifyImageCode: '',
      isShowVcodeWarning: false
    }
  },
  methods: {
    getMeetingInfo: function () {
      const _this = this
      const openLoading = _this.openLoading()
      meetingManageApi.getMeetingInfo({
        meetingID: _this.$route.params.mid
      }).then(data => {
        _this.meetingInfo = data
        _this.$nextTick(() => {
          _this.voteApplyBarStyle.marginTop = _this.$refs.voteApplyHead.offsetHeight + 'px'
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getImageRotateCode: function () {
      const _this = this
      const openLoading = _this.openLoading()
      verificationCodeApi.getImageRotateCode().then(data => {
        _this.verifyImageCode = 'data:image/png;base64,' + data.ImageCode
        _this.verifyEncryptCode = data.EncryptCode
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    openSubmitUserApplyVerify: function (formName) {
      const _this = this
      _this.$refs[formName].validate((valid, object) => {
        if (valid) {
          _this.pictureRotateNum = 0
          _this.getImageRotateCode()
          _this.pictureRotateVerifyVisible = true
        } else {
          for (const i in object) {
            let dom = this.$refs[i]
            if (Object.prototype.toString.call(dom) !== '[object Object]') {
              dom = dom[0]
            }
            dom.$el.scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            })
            break
          }
          return false
        }
      })
    },
    pictureRotateInput: function () {
      const _this = this
      if (_this.pictureRotateNum > 0) {
        _this.sliderLeftStyle.backgroundColor = '#409EFF'
      }
      _this.vcodeImgStyle.transform = 'rotate(' + _this.pictureRotateNum + 'deg)'
    },
    submitUserApply: function (formName) {
      const _this = this
      _this.openLoading('签到中…')
      _this.voteUserApplyForm.CompanyID = _this.$route.params.cid
      _this.voteUserApplyForm.MeetingID = _this.$route.params.mid
      _this.voteUserApplyForm.EncryptCode = _this.verifyEncryptCode
      _this.voteUserApplyForm.RotateNumber = _this.pictureRotateNum
      userApplyApi.editUserApply(_this.voteUserApplyForm).then(data => {
        if (data.Code === 0) {
          _this.isShowVcodeWarning = true
          setTimeout(() => {
            _this.getImageRotateCode()
            _this.pictureRotateNum = 0
            _this.isShowVcodeWarning = false
          }, 1000)
        }
        if (data.Code === 1) {
          _this.pictureRotateVerifyVisible = false
          _this.userApplyInfo = data.ResultData
          _this.viewType = 'detaile'
          _this.$message({
            showClose: true,
            type: 'success',
            message: '签到成功！',
            customClass: 'custom_message'
          })
        }
        if (data.Code === -1) {
          _this.pictureRotateVerifyVisible = false
          _this.$message({
            showClose: true,
            type: 'warning',
            message: data.ResultData,
            customClass: 'custom_message'
          })
        }
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    addUserApply: function () {
      const _this = this
      _this.viewType = 'form'
      _this.voteUserApplyForm = {
        Id: null,
        UserName: null,
        Phone: null,
        UnitName: null,
        Department: null,
        Position: null,
        IsAgent: false,
        ClientName: null,
        ClientPhone: null,
        CompanyID: null,
        MeetingID: null
      }
    },
    getBack: function () {
      const _this = this
      _this.$router.push({ name: 'voteLogin', params: { mid: _this.$route.params.mid, cid: _this.$route.params.cid } })
    }
  },
  created () {
    const _this = this
    _this.getMeetingInfo()
  }
}
</script>
<style lang="less">
@import '../../assets/css/mobileVote/vote.css';
</style>
